import { render, staticRenderFns } from "./MyProfilePage.vue?vue&type=template&id=bb495abe&scoped=true"
import script from "./MyProfilePage.vue?vue&type=script&lang=js"
export * from "./MyProfilePage.vue?vue&type=script&lang=js"
import style0 from "./MyProfilePage.vue?vue&type=style&index=0&id=bb495abe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb495abe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb495abe')) {
      api.createRecord('bb495abe', component.options)
    } else {
      api.reload('bb495abe', component.options)
    }
    module.hot.accept("./MyProfilePage.vue?vue&type=template&id=bb495abe&scoped=true", function () {
      api.rerender('bb495abe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/data-platform/modules/profile/MyProfilePage.vue"
export default component.exports